export var minLength = function minLength(value, size) {
  return value && value.length >= size;
};
export var maxLength = function maxLength(value, size) {
  return value && value.length <= size;
};
export var minValue = function minValue(value, min) {
  return isNumber(value) && value >= min;
};
export var maxValue = function maxValue(value, max) {
  return isNumber(value) && value <= max;
};
export var isNumber = function isNumber(value) {
  return value && parseInt(value, 10) !== NaN;
};
export var isEmail = function isEmail(value) {
  // https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(value);
};
export var validateName = function validateName(value) {
  return minLength(value, 1);
};
export var validatePhoneNumber = function validatePhoneNumber(value) {
  return isNumber(value) && minLength(value, 10) && maxLength(value, 10) && maxValue(value, 9999999999);
};
export var validateEmail = function validateEmail(value, isRequired) {
  var required = minLength(value, 5) && isEmail(value);
  var optional = value ? isEmail(value) : true;
  return isRequired ? required : optional;
};
export var validateEmployees = function validateEmployees(value) {
  return isNumber(value) && maxLength(value, 10) && minValue(value, 1) && maxValue(value, 9999999999);
};
export var validateGroupLeadForm = function validateGroupLeadForm(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      phoneNumber = _ref.phoneNumber,
      email = _ref.email,
      employees = _ref.employees;
  return validateName(firstName) && validateName(lastName) && validatePhoneNumber(phoneNumber) && validateEmail(email) && validateEmployees(employees);
};